var map = {
	"./60fpsparrot.gif": 9991,
	"./abkhaziaparrot.gif": 76397,
	"./accessibleparrot.gif": 80622,
	"./afghanistanparrot.gif": 28734,
	"./albaniaparrot.gif": 74491,
	"./algeriaparrot.gif": 82635,
	"./andorraparrot.gif": 86195,
	"./angelparrot.gif": 41,
	"./angolaparrot.gif": 43493,
	"./angryparrot.gif": 81572,
	"./antarcticaparrot.gif": 74532,
	"./antiguaandbarbudaparrot.gif": 43463,
	"./argentinaparrot.gif": 1066,
	"./armeniaparrot.gif": 50047,
	"./artsakhparrot.gif": 72904,
	"./astronautparrot.gif": 1666,
	"./aussiecongaparrot.gif": 90662,
	"./aussieparrot.gif": 49392,
	"./aussiereversecongaparrot.gif": 43954,
	"./australiaparrot.gif": 99114,
	"./austriaparrot.gif": 52094,
	"./autonomousparrot.gif": 36094,
	"./azerbaijanparrot.gif": 71212,
	"./backwardsparrot.gif": 17339,
	"./badparrot.gif": 50339,
	"./bahamasparrot.gif": 23008,
	"./bahrainparrot.gif": 86674,
	"./balconyparrot.gif": 9509,
	"./bangladeshparrot.gif": 44399,
	"./barbadosparrot.gif": 70060,
	"./batparrot.gif": 12215,
	"./beerparrot.gif": 51235,
	"./belarusparrot.gif": 8305,
	"./belgiumparrot.gif": 30863,
	"./belizeparrot.gif": 28793,
	"./beninparrot.gif": 42475,
	"./beretparrot.gif": 63827,
	"./bhutanparrot.gif": 3506,
	"./bikerparrot.gif": 53035,
	"./biparrot.gif": 2556,
	"./birthdaypartyparrot.gif": 80728,
	"./bluntparrot.gif": 15887,
	"./blurryparrot.gif": 66813,
	"./bobaparrot.gif": 95717,
	"./boliviaparrot.gif": 70954,
	"./boomparrot.gif": 55089,
	"./bootlegparrot.gif": 25497,
	"./boredparrot.gif": 48380,
	"./bosniaandherzegovinaparrot.gif": 46516,
	"./botswanaparrot.gif": 26014,
	"./bouncingparrot.gif": 71715,
	"./braveheartparrot.gif": 86642,
	"./brazilianfanparrot.gif": 51318,
	"./brazilianplayerparrot.gif": 78263,
	"./brazilparrot.gif": 50632,
	"./bruneiparrot.gif": 13746,
	"./bugparrot.gif": 51681,
	"./bulgariaparrot.gif": 68364,
	"./bunnyparrot.gif": 49410,
	"./burkinafasoparrot.gif": 80045,
	"./burundiparrot.gif": 89298,
	"./cakeparrot.gif": 68982,
	"./calvinist_parrot.gif": 63173,
	"./cambodiaparrot.gif": 10126,
	"./cameroonparrot.gif": 40981,
	"./canadaparrot.gif": 60681,
	"./capeverdeparrot.gif": 32174,
	"./capsparrot.gif": 82672,
	"./ceilingparrot.gif": 7771,
	"./centralafricanrepublicparrot.gif": 70802,
	"./chadparrot.gif": 70785,
	"./checkeredflagparrot.gif": 59619,
	"./chefparrot.gif": 19137,
	"./chicoparrot.gif": 16154,
	"./chileparrot.gif": 57956,
	"./chinaparrot.gif": 28280,
	"./christmasparrot.gif": 55699,
	"./coffeeparrot.gif": 39174,
	"./colombiaparrot.gif": 49489,
	"./comorosparrot.gif": 51889,
	"./confusedparrot.gif": 64888,
	"./congaparrot.gif": 32198,
	"./congapartyparrot.gif": 68267,
	"./cookislandsparrot.gif": 46797,
	"./copparrot.gif": 98085,
	"./costaricaparrot.gif": 75577,
	"./covid19parrot.gif": 51495,
	"./croatiaparrot.gif": 91383,
	"./croissantparrot.gif": 1177,
	"./cryingjordanparrot.gif": 693,
	"./cubaparrot.gif": 83233,
	"./cyprusparrot.gif": 51679,
	"./czechrepublicparrot.gif": 91418,
	"./dadparrot.gif": 49485,
	"./daftpunkparrot.gif": 63400,
	"./dailyparrot.gif": 77915,
	"./darkmodeparrot.gif": 84738,
	"./dealwithitnowparrot.gif": 34520,
	"./dealwithitparrot.gif": 71307,
	"./democraticrepublicofthecongoparrot.gif": 57088,
	"./denmarkparrot.gif": 67987,
	"./discoduck.gif": 85905,
	"./discoparrot.gif": 45159,
	"./djiboutiparrot.gif": 83079,
	"./docparrot.gif": 19469,
	"./dogeparrot.gif": 28989,
	"./dominicanrepublicparrot.gif": 29688,
	"./dominicaparrot.gif": 76081,
	"./donutparrot.gif": 99283,
	"./easttimorparrot.gif": 58369,
	"./ecuadorparrot.gif": 23327,
	"./egyptparrot.gif": 87680,
	"./elsalvadorparrot.gif": 38689,
	"./england.gif": 27543,
	"./equatorialguineaparrot.gif": 36354,
	"./eritreaparrot.gif": 68945,
	"./estoniaparrot.gif": 92403,
	"./eswatiniparrot.gif": 63787,
	"./ethiopiaparrot.gif": 86533,
	"./euparrot.gif": 78133,
	"./everythingsfineparrot.gif": 73866,
	"./evilparrot.gif": 33532,
	"./exceptionallyfastparrot.gif": 36139,
	"./falklandislandsparrot.gif": 58818,
	"./fastparrot.gif": 10791,
	"./fijiparrot.gif": 41603,
	"./finlandparrot.gif": 50437,
	"./flowerparrot.gif": 27667,
	"./flyingmoneyparrot.gif": 8725,
	"./footballparrot.gif": 29982,
	"./franceparrot.gif": 78641,
	"./freebelarusparrot.gif": 35653,
	"./frenchparrot.gif": 13893,
	"./gabonparrot.gif": 47559,
	"./gambiaparrot.gif": 64182,
	"./gentlemanparrot.gif": 13348,
	"./georgiaparrot.gif": 96072,
	"./germanyparrot.gif": 43992,
	"./ghanaparrot.gif": 72661,
	"./githubparrot.gif": 13420,
	"./glimpseparrot.gif": 3919,
	"./gothparrot.gif": 62885,
	"./greeceparrot.gif": 51560,
	"./greekmacedoniaparrot.gif": 85400,
	"./greenlandparrot.gif": 13790,
	"./grenadaparrot.gif": 40310,
	"./grouchoparrot.gif": 89062,
	"./guatemalaparrot.gif": 82903,
	"./guineabissauparrot.gif": 57145,
	"./guineaparrot.gif": 11110,
	"./gumiparrot.gif": 42073,
	"./guyanaparrot.gif": 72684,
	"./haitiparrot.gif": 68127,
	"./hanamiparrot.gif": 67060,
	"./hardhatparrot.gif": 79972,
	"./harpoparrot.gif": 91973,
	"./headbangingparrot.gif": 17028,
	"./headingparrot.gif": 73912,
	"./headsetparrot.gif": 63564,
	"./hmmparrot.gif": 8101,
	"./hondurasparrot.gif": 53784,
	"./hongkongparrot.gif": 4350,
	"./horizontalparrot.gif": 61168,
	"./hungaryparrot.gif": 8264,
	"./hypnoparrot.gif": 10850,
	"./hypnoparrotdark.gif": 42495,
	"./hypnoparrotlight.gif": 9248,
	"./icelandparrot.gif": 97181,
	"./illuminatiparrot.gif": 52065,
	"./imposterparrot.gif": 31062,
	"./indiaparrot.gif": 70588,
	"./indonesiaparrot.gif": 27279,
	"./innersourceparrot.gif": 78574,
	"./inverseparrot.gif": 97813,
	"./invisibleparrot.gif": 59396,
	"./iranparrot.gif": 48782,
	"./iraqparrot.gif": 87712,
	"./irelandparrot.gif": 80271,
	"./israelparrot.gif": 5638,
	"./italyparrot.gif": 12579,
	"./ivorycoastparrot.gif": 36028,
	"./jamaicaparrot.gif": 72967,
	"./japanparrot.gif": 2803,
	"./jediparrot.gif": 99044,
	"./jordanparrot.gif": 4456,
	"./jumpingparrot.gif": 57272,
	"./jumpingparrotjr.gif": 89942,
	"./kazakhstanparrot.gif": 2659,
	"./kenyaparrot.gif": 49821,
	"./kindasusparrot.gif": 30029,
	"./kiribatiparrot.gif": 23293,
	"./kosovoparrot.gif": 53703,
	"./kuwaitparrot.gif": 51428,
	"./kyrgyzstanparrot.gif": 44302,
	"./laosparrot.gif": 42401,
	"./laptop_parrot.gif": 79416,
	"./latviaparrot.gif": 68821,
	"./lebanonparrot.gif": 33868,
	"./lesothoparrot.gif": 85236,
	"./levitationparrot.gif": 27492,
	"./liberiaparrot.gif": 46419,
	"./libyaparrot.gif": 78297,
	"./liechtensteinparrot.gif": 74209,
	"./lithuaniaparrot.gif": 56458,
	"./luxembourgparrot.gif": 11325,
	"./macauparrot.gif": 86892,
	"./madagascarparrot.gif": 18683,
	"./malawiparrot.gif": 65560,
	"./malaysiaparrot.gif": 41922,
	"./maldivesparrot.gif": 1528,
	"./maliparrot.gif": 76507,
	"./maltaparrot.gif": 41084,
	"./maracasparrot.gif": 64243,
	"./mardigrasparrot.gif": 82249,
	"./marshallislandsparrot.gif": 54506,
	"./marshmallowparrot.gif": 61063,
	"./maskparrot.gif": 3329,
	"./mateparrot.gif": 84426,
	"./mauritaniaparrot.gif": 7335,
	"./mauritiusparrot.gif": 33298,
	"./meldparrot.gif": 11276,
	"./mergeconflictparrot.gif": 8074,
	"./mergeimmediatelyparrot.gif": 23276,
	"./mergetrainparrot.gif": 63085,
	"./mexicoparrot.gif": 39810,
	"./michaeljacksonparrot.gif": 53105,
	"./micronesiaparrot.gif": 36702,
	"./middleparrot.gif": 28426,
	"./moldovaparrot.gif": 96040,
	"./monacoparrot.gif": 59102,
	"./mongoliaparrot.gif": 8459,
	"./montenegroparrot.gif": 79490,
	"./moonparrot.gif": 7802,
	"./moonwalkingparrot.gif": 35080,
	"./moroccoparrot.gif": 51984,
	"./mozambiqueparrot.gif": 33792,
	"./mustacheparrot.gif": 47245,
	"./myanmarparrot.gif": 70117,
	"./namibiaparrot.gif": 23285,
	"./nauruparrot.gif": 61945,
	"./nepalparrot.gif": 61697,
	"./netherlandsparrot.gif": 34154,
	"./newzealandparrot.gif": 88203,
	"./nicaraguaparrot.gif": 8958,
	"./nigeriaparrot.gif": 39512,
	"./nigerparrot.gif": 41035,
	"./niueparrot.gif": 86271,
	"./nodeparrot.gif": 53854,
	"./northern-ireland-st-patricks-saltire.gif": 60666,
	"./northern-ireland-ulster-banner.gif": 68077,
	"./northerncyprusparrot.gif": 44322,
	"./northkoreaparrot.gif": 40352,
	"./northmacedoniaparrot.gif": 5224,
	"./norwayparrot.gif": 15677,
	"./norwegianblueparrot.gif": 24472,
	"./nyanparrot.gif": 58205,
	"./omanparrot.gif": 65162,
	"./opensourceparrot.gif": 15754,
	"./originalparrot.gif": 75056,
	"./pakistanparrot.gif": 22109,
	"./palauparrot.gif": 32296,
	"./palestineparrot.gif": 99383,
	"./panamaparrot.gif": 8018,
	"./papuanewguineaparrot.gif": 72027,
	"./paraguayparrot.gif": 19052,
	"./parrot.gif": 51734,
	"./parrotnotfound.gif": 54861,
	"./parrotpoop.gif": 70716,
	"./party-k8s.gif": 10626,
	"./party-wizard.gif": 17621,
	"./partyannoyedbird.gif": 68536,
	"./partyblob.gif": 31051,
	"./partyblobcat.gif": 28912,
	"./partycage.gif": 84992,
	"./partyfieri.gif": 97557,
	"./partyfsjal.gif": 22267,
	"./partygeeko.gif": 66302,
	"./partygfm.gif": 81809,
	"./partygopher.gif": 69099,
	"./partygritty.gif": 27440,
	"./partykeanu.gif": 93282,
	"./partymoogle.gif": 21350,
	"./partyparrot.gif": 79161,
	"./partypicard.gif": 97291,
	"./partysloth.gif": 66921,
	"./partywumpus.gif": 13813,
	"./peruparrot.gif": 29901,
	"./philippinesparrot.gif": 40522,
	"./phparrot.gif": 56090,
	"./picassoparrot.gif": 58754,
	"./pingpongparrot.gif": 99167,
	"./pirateparrot.gif": 52749,
	"./playcatchleftparrot.gif": 2592,
	"./playcatchrightparrot.gif": 41426,
	"./pokeparrot.gif": 15425,
	"./polandparrot.gif": 67165,
	"./popcornparrot.gif": 6020,
	"./portalblueparrot.gif": 19276,
	"./portalorangeparrot.gif": 31528,
	"./portugalparrot.gif": 76893,
	"./preetjusticeparrot.gif": 65602,
	"./prideparrot.gif": 68708,
	"./puertoricoparrot.gif": 68720,
	"./pumpkinparrot.gif": 4042,
	"./qatarparrot.gif": 60391,
	"./quadparrot.gif": 88253,
	"./quebecparrot.gif": 11352,
	"./raceconditionparrot.gif": 10908,
	"./reactparrot.gif": 59049,
	"./redbullparrot.gif": 22573,
	"./redenvelopeparrot.gif": 25044,
	"./redhatparrot.gif": 87120,
	"./republicofthecongoparrot.gif": 68887,
	"./reversecongaparrot.gif": 99102,
	"./reverseparrot.gif": 2687,
	"./reverseportalblueparrot.gif": 69367,
	"./reverseportalorangeparrot.gif": 2733,
	"./revolutionparrot.gif": 74639,
	"./ripparrot.gif": 8046,
	"./romaniaparrot.gif": 68183,
	"./rubyparrot.gif": 15241,
	"./russiaparrot.gif": 30764,
	"./rwandaparrot.gif": 8528,
	"./rythmicalparrot.gif": 18245,
	"./sadparrot.gif": 68066,
	"./sahrawiarabdemocraticrepublicparrot.gif": 90275,
	"./saintkittsandnevisparrot.gif": 58887,
	"./saintluciaparrot.gif": 24097,
	"./saintvincentandthegrenadinesparrot.gif": 852,
	"./samoaparrot.gif": 91572,
	"./sanmarinoparrot.gif": 46015,
	"./saotomeandprincipeparrot.gif": 35816,
	"./sassyparrot.gif": 33581,
	"./saudiarabiaparrot.gif": 10160,
	"./scienceparrot.gif": 13978,
	"./scotland.gif": 24277,
	"./senegalparrot.gif": 9851,
	"./serbiaparrot.gif": 8307,
	"./seychellesparrot.gif": 17498,
	"./sherlockholmesparrot.gif": 88029,
	"./shortparrot.gif": 85064,
	"./shuffleparrot.gif": 1257,
	"./sidewaysparrot.gif": 76251,
	"./sierraleoneparrot.gif": 28098,
	"./singaporeparrot.gif": 3103,
	"./sintparrot.gif": 57683,
	"./sithparrot.gif": 74870,
	"./sleepingparrot.gif": 69109,
	"./slovakiaparrot.gif": 46137,
	"./sloveniaparrot.gif": 30864,
	"./slowparrot.gif": 88737,
	"./sneezyparrot.gif": 30911,
	"./soccerparrot.gif": 5194,
	"./solomonislandsparrot.gif": 2540,
	"./somaliaparrot.gif": 29691,
	"./somalilandparrot.gif": 10273,
	"./southafricaparrot.gif": 55928,
	"./southkoreaparrot.gif": 88814,
	"./southossetiaparrot.gif": 93520,
	"./southsudanparrot.gif": 25198,
	"./spainparrot.gif": 27061,
	"./spinningparrot.gif": 76892,
	"./spyparrot.gif": 53777,
	"./srilankaparrot.gif": 18929,
	"./stableparrot.gif": 54327,
	"./stayhomeparrot.gif": 27012,
	"./stayhomeparrotcloser.gif": 44159,
	"./stayhomeparrotwindow.gif": 57814,
	"./staytfhomeparrot.gif": 75360,
	"./stubparrot.gif": 14058,
	"./sudanparrot.gif": 92180,
	"./surinameparrot.gif": 80875,
	"./sushiparrot.gif": 2705,
	"./swedenparrot.gif": 32761,
	"./switzerlandparrot.gif": 68980,
	"./syriaparrot.gif": 30013,
	"./taiwanparrot.gif": 36365,
	"./tajikistanparrot.gif": 11708,
	"./tanzaniaparrot.gif": 81951,
	"./tennisparrot.gif": 43452,
	"./thailandparrot.gif": 23613,
	"./thankyouparrot.gif": 12747,
	"./thefastestparrot.gif": 50231,
	"./thisisfineparrot.gif": 38621,
	"./thumbsupparrot.gif": 69549,
	"./tiedyeparrot.gif": 42935,
	"./tinfoilhatparrot.gif": 58724,
	"./togoparrot.gif": 3233,
	"./tongaparrot.gif": 36634,
	"./tpparrot.gif": 90677,
	"./transnistriaparrot.gif": 59093,
	"./transparront.gif": 19734,
	"./transparrot.gif": 73446,
	"./trinidadandtobagoparrot.gif": 32657,
	"./trollparrot.gif": 60162,
	"./tunisiaparrot.gif": 56200,
	"./turkeyparrot.gif": 15245,
	"./turkmenistanparrot.gif": 39705,
	"./turndownforwatchparrot.gif": 21195,
	"./tuvaluparrot.gif": 73807,
	"./twinsparrot.gif": 98376,
	"./ugandaparrot.gif": 44795,
	"./ukraineparrot.gif": 40090,
	"./ultrafastparrot.gif": 57256,
	"./unicornparrot.gif": 30977,
	"./unitedarabemiratesparrot.gif": 35111,
	"./unitedkingdomparrot.gif": 2367,
	"./unitedstatesofamericaparrot.gif": 23557,
	"./uruguayparrot.gif": 60449,
	"./uzbekistanparrot.gif": 94819,
	"./vaccineparrot.gif": 26752,
	"./vanuatuparrot.gif": 39906,
	"./vaticancityparrot.gif": 57668,
	"./venezuelaparrot.gif": 94351,
	"./verticalparrot.gif": 48865,
	"./vibepartycat.gif": 36566,
	"./vietnamparrot.gif": 25708,
	"./vikingparrot.gif": 954,
	"./vueparrot.gif": 1034,
	"./wales.gif": 23473,
	"./wendyparrot.gif": 52812,
	"./westernsaharaparrot.gif": 19100,
	"./wfhparrot.gif": 59303,
	"./whitewalkerparrot.gif": 86850,
	"./wineparrot.gif": 18972,
	"./witnessprotectionparrot.gif": 50745,
	"./yemenparrot.gif": 35152,
	"./yosemitesamparrot.gif": 22211,
	"./zambiaparrot.gif": 16466,
	"./zimbabweparrot.gif": 15138,
	"./zombieparrot.gif": 16335,
	"./zoukparrot.gif": 63370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11005;